import Link from "next/link";

const CustomNavLink = ({
  href,
  className = "text-gray-700 hover:text-blue-600 text-base font-medium hover:cursor-pointer flex justify-center items-center gap-1",
  children,
  ...props
}) => {
  return (
    <Link href={href || "#"} rel="noreferrer" className={className} {...props}>
      {children}
    </Link>
  );
};

export default CustomNavLink;
